import { z } from 'zod';

export const IntegrationSchema = z.object({
  accountId: z.string(),
  id: z.string(),
  propertyId: z.number(),
  name: z.string(),
  isRefreshTokenValid: z.boolean().nullable(),
});

export const integrationsResponseSchema = z.object({
  data: z.object({
    items: z.array(IntegrationSchema),
  }),
});

export const selectGoogleAnalyticsIntegrationRequestSchema = z.object({
  activityId: z.string(),
  integrationId: z.string(),
});

export const selectGoogleAnalyticsIntegrationRequestDeprecatedSchema = z.object(
  {
    campaignCollectionId: z.string(),
    integrationId: z.string(),
  },
);

export type IntegrationsResponseType = z.infer<
  typeof integrationsResponseSchema
>;

export type IntegrationType = z.infer<typeof IntegrationSchema>;
export type SelectGoogleAnalyticsIntegrationRequestType = z.infer<
  typeof selectGoogleAnalyticsIntegrationRequestSchema
>;
